<template>
  <QS-scroller-box v-loading="tableLoading">
    <section>
      <QS-h4-title title="退车核算">
        <QSColumnBox label-width="90">
          <template>
            <div>
              <div
                class="el-column-box__title is_required"
                style="width: 160px; flex-shrink: 0;"
              >
                车辆交接完成时间:
              </div>
              <div class="el-column-box__content">
                <el-date-picker
                  :disabled="!isEdit"
                  v-model="infoData.takeOverTime"
                  :picker-options="pickerOptions"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  @change="timeChangeHandle"
                  style="width: auto;"
                >
                </el-date-picker>
              </div>
            </div>

            <div>
              <div class="el-column-box__title">应付租金:</div>
              <div class="el-column-box__content">
                {{
                  `${infoData.payRentAmount ||
                    '--'}元（已付租金：${infoData.paidRentAmount || '--'}元）`
                }}
              </div>
            </div>
            <div>
              <div class="el-column-box__title">应付押金:</div>
              <div class="el-column-box__content">
                {{
                  `${infoData.payDepositAmount ||
                    '--'}元（已付押金：${infoData.paidDepositAmount ||
                    '--'}元）`
                }}
              </div>
            </div>
          </template>
        </QSColumnBox>
        <QSColumnBox v-if="!isEdit" label-width="90">
          <template>
            <div>
              <div class="el-column-box__title">应退租金:</div>
              <div class="el-column-box__content">
                {{ `${infoData.returnCarAmount || '--'}元` }}
              </div>
            </div>
            <div>
              <div class="el-column-box__title">应退押金:</div>
              <div class="el-column-box__content">
                {{ `${infoData.returnDepositAmount || '--'}元` }}
              </div>
            </div>
            <div>
              <div class="el-column-box__title">需补欠款:</div>
              <div class="el-column-box__content">
                {{ `${infoData.needPatchAmount || '--'}元` }}
              </div>
            </div>
          </template>
        </QSColumnBox>
      </QS-h4-title>
    </section>

    <!-- 尽可能不破坏之前props逻辑，后传入isDisabled进行判断 -->
    <operation
      :state="orderState"
      :operation="operation"
      :isDisabled="!isEdit"
    ></operation>
    <section>
      <QS-h4-title title="支付款项"></QS-h4-title>
      <div class="add-payment-box" v-if="isEdit">
        <div class="add-payment-left">
          <span class="label">增加支付项：</span>
          <el-select v-model="selectPaymentVal" placeholder="请选择">
            <el-option
              v-for="item in settleMentFeeFilteredList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click="addPayment">添加</el-button>
        </div>
        <div class="add-payment-right">
          <div class="content">
            <span class="title">应退押金：</span>
            <span class="value">{{ returnDepositCpt || defaultAmount }}元</span>
          </div>
          <div class="content ml16">
            <span class="title">应退租金：</span>
            <span class="value"
              >{{ returnCarAmountCpt || defaultAmount }}元</span
            >
          </div>
          <div class="content ml16">
            <span class="title">需补欠款：</span>
            <span class="value">{{ needAmountCpt || defaultAmount }}元</span>
          </div>
        </div>
      </div>
      <el-table
        :data="paymentList"
        height="500"
        cell-class-name="custom-cell-class"
      >
        <el-table-column prop="title" label="支付内容" width="110">
        </el-table-column>
        <el-table-column
          label="收款方"
          width="100"
          v-if="orderData.serviceName"
        >
          <template slot-scope="">{{ orderData.serviceName }}</template>
        </el-table-column>
        <el-table-column label="支付金额（元）" width="180">
          <template slot-scope="{ row, $index }">
            <div v-if="isEdit">
              <!-- 只有违约金有 切换支付方式 -->
              <div v-if="row.title === '违约金'">
                <!-- 固定金额输入框 -->
                <el-input
                  v-if="isFixed"
                  v-model="row.amount"
                  placeholder="请输入"
                  @input="val => moneyBlur(val, $index, true)"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
                <!-- 按核算比例输入框 + 提示 -->
                <div v-else>
                  <el-input
                    v-model="percent"
                    placeholder="请输入"
                    @input="val => moneyPercentBlur(val, $index)"
                  >
                    <template slot="append"
                      >%</template
                    >
                  </el-input>
                  <div class="tips" style="padding-left: 0;">
                    <p>
                      剩余租期租金：{{
                        `${infoData.surplusPaymentAmount || '0.00'}`
                      }}
                      元
                    </p>
                    <p>当前比例违约金金额：{{ row.amount || '0.00' }}元</p>
                    <p
                      class="el-icon-info"
                      v-show="Number(infoData.surplusPaymentAmount) === 0"
                    >
                      &nbsp;当前租期剩余租金为0，无法按比例结算
                    </p>
                  </div>
                </div>
                <el-button
                  @click="changeInputHandle($index)"
                  class="mt16"
                  type="text"
                  icon="el-icon-s-operation"
                >
                  {{ changeBtnText }}
                </el-button>
              </div>
              <!-- 除了违约金其他行的固定金额输入框 -->
              <el-input
                v-else
                v-model="row.amount"
                placeholder="请输入"
                @input="val => moneyBlur(val, $index)"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </div>
            <div v-else>{{ row.amount || '0.00' }}元</div>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="{ row }">
            <div v-if="isEdit">
              <el-input
                v-model="row.remarks"
                type="textarea"
                placeholder="请输入备注"
                maxlength="500"
                show-word-limit
              >
              </el-input>
            </div>
            <div v-else>
              {{ row.remarks || '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="400">
          <template slot-scope="{ row }">
            <div v-if="!isEdit" class="box-photos">
              <div
                class="item"
                v-for="(item, index) in row.photos"
                :key="index"
              >
                <EnlargeImg :imgSrc="item.url" />
              </div>
            </div>
            <UploadCommon
              v-else
              :fileList="row.photos"
              :limit="3"
              :showUploadBtnByLimit="3"
              :isAlone="false"
              :isShowTitle="false"
              :sizeType="4"
              commonUpload
              group="finance"
              code="finance_pay_agreement_pic"
            >
            </UploadCommon>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60" v-if="isEdit">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              v-if="row.isHandle"
              @click="handleDelete($index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <template v-if="isEdit" slot="bottomAction">
      <el-button size="small" @click="toBackPage">取消</el-button>
      <template>
        <el-button
          v-show="!approvalStateStatus"
          type="primary"
          size="small"
          @click="submitInfo('save')"
          >保存</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-show="isShowSaveBtn && !approvalStateStatus"
          v-submitDingTalkShow="25"
          @click="submitInfo('confirm')"
          >提交</el-button
        >
        <el-button
          v-show="isShowSaveBtn && approvalStateStatus"
          type="primary"
          @click="handleShowApprovalTask"
          >查看审批动态</el-button
        >
      </template>
    </template>
    <ApprovalTaskDetail
      :approvalTaskDetailDialogVisible.sync="approvalTaskDetailDialogVisible"
      :bizId="orderData.purchaseOrderId"
      bizType="25"
    />
  </QS-scroller-box>
</template>

<script>
import {
  calculateCarAmount,
  confirmSettlement,
  getSettlementDetail,
  saveSettlement,
} from '@/api/purchaseAndSaleAPI/purchaseOrderApi'
import ApprovalTaskDetail from '@/components/ApprovalTaskDetail/index.vue'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import { limitMoreZero, limitMoreZeroByPercent } from '@/utils/validate'
import _cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { mapState } from 'vuex'
import operation from './returnContent/operation.vue'

let startDate = ''
export default {
  components: {
    operation,
    ApprovalTaskDetail,
  },
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  data() {
    return {
      approvalState: '', // 当前审批状态 10 带审批 （前端展示审批动态） 20 已经撤回 30 已驳回 40 已通过
      approvalTaskDetailDialogVisible: false,
      pickerOptions: {
        disabledDate(date) {
          // 服务端返回的开始时间之前不能选择
          return date.getTime() < new Date(startDate).getTime() - 8.64e7
        },
      },
      isShowSaveBtn: false, // 是否展示保存按钮
      isEdit: true,
      isFixed: true, // 支付方式  固定金额: true, 按核算比例：false
      percent: '0.00', // 违约金 百分比
      paymentList: [],
      orderId: '',
      infoData: {},
      selectPaymentVal: null,
      operation: {
        amount: '0.00',
        remark: '',
        photos: [],
      },
      defaultAmount: '0.00',
      tableLoading: false,
    }
  },
  inject: ['orderData'],
  methods: {
    // 点击查看 审批流进程 处理新增 钉钉审批流 财务场景
    async handleShowApprovalTask() {
      this.approvalTaskDetailDialogVisible = true
    },
    changeInputHandle(index) {
      if (this.isFixed) {
        // 初始化比例， 在切换的时候触发
        this.moneyBlur(this.paymentList[index].amount, index, true)
      }
      this.isFixed = !this.isFixed
      if (!this.isFixed) {
        const current = Number(this.paymentList[index].amount)
        const total = Number(this.infoData.surplusPaymentAmount)

        if (current > total) {
          this.paymentList[index].amount = total
          this.$set(this.paymentList, index, this.paymentList[index])
        }
      }
    },
    // 固定金额 input事件 计算
    moneyBlur(value, index, isDefault) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      limitMoreZero(
        value,
        (res) => {
          self.paymentList[index].amount = res
          // 违约金字段才计算比例
          if (isDefault) {
            // 比例 = 违约金金额 / 剩余租期租金
            if (Number(self.infoData.surplusPaymentAmount) === 0) {
              self.percent = '0.00'
            } else {
              let num =
                (Number(self.paymentList[index].amount) /
                  Number(self.infoData.surplusPaymentAmount)) *
                100
              num = num > 100 ? 100 : num // 违约金金额 = 剩余租期租金 * 已输入的比例
              self.percent = num.toFixed(2)
            }
          }
        },
        7,
      )
    },
    // 按比例 input 事件 计算
    moneyPercentBlur(value, index) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      limitMoreZeroByPercent(value, (res) => {
        if (Number(self.infoData.surplusPaymentAmount) === 0) {
          self.percent = '0.00'
        } else {
          self.percent = res
          const num =
            Number(self.infoData.surplusPaymentAmount) * (Number(res) / 100)
          self.paymentList[index].amount = num.toFixed(2)
        }
      })
    },
    async getInfo(orderId) {
      if (!orderId) return
      this.tableLoading = true
      await this.$store.dispatch('getPaymentMethods', {
        type: 'settlementFeeType',
      }) //  结算费项枚举
      const { code, data } = await getSettlementDetail({ orderId })
      if (code !== 1) {
        this.tableLoading = false
        return
      }
      const infoData = data || {}

      if (this.$route.query.time) {
        infoData.takeOverTime = moment(this.$route.query.time)
      }
      this.infoData = infoData
      // 如果有时间需要计算金额
      if (infoData.takeOverTime) this.timeChangeHandle(infoData.takeOverTime)
      // settlementState：订单状态 0-未完成 1-已完成
      this.isEdit = infoData.settlementState !== 1
      // 运营情况
      this.operation.amount = infoData.operationFlowAmount
      this.operation.remark = infoData.operationFlowRemarks
      this.operation.photos = this.getURL({ data: infoData.operationFlowPhotos, defaultImg: [], needName: true })
      this.paymentList = infoData.orderSettlementItems.map((item) => {
        item.fixFlag ? (item.isHandle = false) : (item.isHandle = true)
        item.type = item.payContent
        item.title = (
          this.settleMentFeeList.filter((v) => v.code === item.payContent)[0] ||
          {}
        ).name
        item.photos = this.getURL({ data: item.photos, defaultImg: [], needName: true })
        return item
      })
      this.tableLoading = false
    },
    // 添加支付项
    addPayment() {
      if (!this.selectPaymentVal) {
        this.$message.warning('请添加支付项')
        return
      }
      const label = (
        this.settleMentFeeList.filter(
          (item) => item.code === this.selectPaymentVal,
        )[0] || {}
      ).name
      const { sort } =
        this.settleMentFeeList.filter(
          (item) => item.code === this.selectPaymentVal,
        )[0] || {}
      const findPaymentVal = this.paymentList.filter(
        (item) => item.type === this.selectPaymentVal,
      )
      if (findPaymentVal.length !== 0) {
        this.$message.warning('请勿添加重复的支付项')
        return
      }
      const data = {
        sort,
        title: label,
        type: this.selectPaymentVal,
        amount: '0.00',
        remarks: '',
        photos: [],
        isHandle: true,
      }
      this.paymentList.push(data)
    },
    // 删除支付项
    handleDelete(index) {
      this.paymentList.splice(index, 1)
    },
    handleInfo() {
      const param = {
        orderId: this.orderId,
        settlementItems: [],
        refundableDepositAmount: this.returnDepositCpt, // 应退押金
        refundableRentAmount: this.returnCarAmountCpt || 0, // 应退租金
        needPatchAmount: this.needAmountCpt, // 需补欠款
        payDepositAmount: this.infoData.payDepositAmount || 0, // 应付押金
        paidDepositAmount: this.infoData.paidDepositAmount || 0, // 已付押金 paidDepositAmount
        payAmount: this.infoData.payRentAmount || 0, // 应付租金
        paidAmount: this.infoData.paidRentAmount || 0, // 已付租金
        takeOverTime: this.infoData.takeOverTime, // 车辆交接完成时间
      }
      // 运营情况
      param.operationFlowAmount = this.operation.amount || 0
      if (this.operation.remark) {
        param.operationFlowRemarks = this.operation.remark
      }
      param.operationFlowPhotos = this.getUoloadCommonFileData(this.operation.photos)
      // 支付款项
      param.settlementItems = this.paymentList.map((item) => {
        const itemPhotos = this.getUoloadCommonFileData(item.photos)
        return {
          payContent: item.type,
          sort: item.sort,
          amount: item.amount,
          remarks: item.remarks,
          photos: itemPhotos,
        }
      })
      param.returnCarInfo = [
        {
          orderId: this.orderId,
          takeOverTime: this.infoData.takeOverTime,
        },
      ]
      return param
    },
    // 保存/提交退车
    submitInfo(type) {
      const { from } = this.$route.query
      const settleApi = {
        save: saveSettlement,
        confirm: confirmSettlement,
      }
      if (!this.infoData.takeOverTime) {
        this.$message.error('车辆完成交接时间不能为空！')
        return
      }
      const submitApi = () => {
        settleApi[type]({ ...this.handleInfo() }).then((res) => {
          if (res.code === 1) {
            const msg =
              type === 'confirm' && this.DingTalkShow25
                ? '提交审批成功'
                : '提交成功'
            this.$message.success(msg)
            if (from) this.updateItemTime({ ...this.handleInfo() })
            this.toBackPage(true)
          } else if (res.code === 24012) {
            // 网约钱包支付提示
            this.$confirm(
              '有正在进行中的网约钱包支付,可等待网约钱包支付完成后再进行核算或手动终止',
              '提示',
              {
                confirmButtonText: '去终止',
                cancelButtonText: '取消',
                type,
              },
            ).then(() => {
              // TODO: 待确认id
              this.$router.push({
                path: '/finance/withholdPlanList',
                id: '',
              })
            })
          } else if (res.code === 24013) {
            // 支付宝支付提示
            this.$alert(
              '有正在进行中的支付宝支付,请完成支付宝支付后再进行核算',
              '提示',
              {
                confirmButtonText: '关闭',
                callback: () => null,
              },
            )
          }
        })
      }
      if (type === 'confirm') {
        this.$confirm(
          '确认后将提交到财务核算，将无法再次修改金额',
          '确认是否提交',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          },
        )
          .then(() => {
            submitApi()
          })
          .catch(() => null)
        return
      }
      submitApi()
    },
    // 退车信息修改后，更新缓存中退车列表中对应车辆的退车时间
    updateItemTime(data) {
      const nowTime = data.takeOverTime
      const sessionCarInfo = JSON.parse(
        sessionStorage.getItem('batchExitCarlistObj'),
      )
      const sessionCarlist = JSON.parse(sessionCarInfo.list)
      const id = this.orderData.carId || sessionCarInfo.carId
      // console.log(id, sessionCarlist)
      const relationCar = sessionCarlist.find((item) => item.carId === id)
      relationCar.returnCarDate = nowTime
      sessionCarInfo.list = JSON.stringify(sessionCarlist)
      sessionStorage.setItem(
        'batchExitCarlistObj',
        JSON.stringify(sessionCarInfo),
      )
    },
    toBackPage(status = false) {
      this.$refreshBack(status)
    },
    // 时间change
    timeChangeHandle(val) {
      this.infoData.takeOverTime = val
        ? moment(val).format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.calculateReceivableAmount()
    },
    // 计算 到退车交接完成时间的应收金额 和 剩余租期的应收金额
    async calculateReceivableAmount() {
      const { code, data } = await calculateCarAmount({
        orderId: this.orderId,
        carId: this.orderData.carId,
        returnCarDate: this.infoData.takeOverTime,
      })
      if (code === 1) {
        this.infoData.surplusPaymentAmount = data && data.surplusAmount
        this.infoData.payRentAmount = data && data.rentAmount
      }
    },
  },
  watch: {
    orderData: {
      handler(v) {
        startDate = v.startDate || ''
        this.approvalState = v.approvalState
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      settleMentFeeList: (state) => state.global.settleMentFeeList, // 结算费项
    }),
    approvalStateStatus() {
      return Number(this.orderData.approvalState) === 10
    },
    // 页面增加支付费项的枚举 需要过滤掉接口返回的几个费项目 和 1-租金、2-押金
    settleMentFeeFilteredList() {
      let na = []
      const settleMentFeeListClone = _cloneDeep(this.settleMentFeeList)
      let codeList = this.paymentList.reduce((total, i) => {
        return total.concat(i.type)
      }, [])
      codeList = codeList.concat([1, 2])
      if (codeList && codeList.length > 0) {
        na = settleMentFeeListClone.filter(
          (item) => !codeList.includes(item.code),
        )
      }
      return na
    },
    // 违约金按钮切换文案
    changeBtnText() {
      return this.isFixed ? '按比例核算' : '固定金额'
    },
    /**
     * 以下计算属性都是本页面需要前端参与计算的
     */
    // #region
    // 1. 支付款项：表格所有列之和
    paymentAmountCpt() {
      let paymentAmountSum = 0
      this.paymentList.forEach((item) => {
        paymentAmountSum += Number(item.amount)
      })
      return Number(paymentAmountSum.toFixed(2))
    },
    // 2.(已付租金<应付租金)需补租金：应收租金 - 已收租金 > 0 ? 计算后的值 : 0
    needCarAmountCpt() {
      const amount = this.infoData.payRentAmount - this.infoData.paidRentAmount
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    // 3. 剩余应退押金：已收押金 - 需补租金 > 0 ? 计算后的值 : 0
    residueReturnDepositCpt() {
      const amount = this.infoData.paidDepositAmount - this.needCarAmountCpt
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    // 4. 应退押金：剩余应退押金 - 支付款项 > 0 ? 计算后的值 : 0
    returnDepositCpt() {
      const amount = this.residueReturnDepositCpt - this.paymentAmountCpt
      return amount > 0 ? amount.toFixed(2) : 0
    },
    // 5.(押金不够退的时候) 剩余支付款项：支付款项 - 剩余应退押金 > 0 ? 计算后的值 : 0
    residuePaymentAmountCpt() {
      const amount = this.paymentAmountCpt - this.residueReturnDepositCpt
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    /**
     * 6. 应退租金：已收租金 - 应收租金 - 剩余支付款项 > 0 ? 计算后的值 : 0
     */
    returnCarAmountCpt() {
      const amount =
        this.infoData.paidRentAmount -
        this.infoData.payRentAmount -
        this.residuePaymentAmountCpt
      return amount > 0 ? amount.toFixed(2) : 0
    },
    /**
     * 7. 需补欠款：支付款项 - 已收押金 - (已收租金 - 应收租金) > 0 ? 计算后的值 : 0
     */
    needAmountCpt() {
      const amount =
        this.paymentAmountCpt -
        this.infoData.paidDepositAmount -
        (this.infoData.paidRentAmount - this.infoData.payRentAmount)
      return amount > 0 ? amount.toFixed(2) : 0
    },
    // #endregion
    // 采购订单运营情况适配 operation 组件
    orderState() {
      return this.infoData.closeTime ? 5500 : 4500
    },
  },
  created() {
    startDate = this.orderData.startDate || ''
    const { id } = this.$route.query
    this.orderId = id
    this.isShowSaveBtn = !this.$route.query.from
    this.getInfo(id)
  },
}
</script>
<style lang="scss" scoped>
.add-payment-box {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 20px;

  .add-payment-right {
    display: flex;
  }
}

::v-deep .custom-cell-class {
  vertical-align: top;

  .cell {
    padding-top: 10px;
  }
}
.box-photos {
  display: flex;
  flex-wrap: wrap;

  .item {
    margin-left: 16px;
    width: 80px;
    height: 80px;

    &:nth-child(5n + 1) {
      margin-left: 0;
    }

    &:nth-child(n + 6) {
      margin-top: 30px;
    }
  }
}
.is_required::before {
  position: relative;
  top: 4px;
  content: '*';
  margin-right: 4px;
  font-size: 18px;
  color: #ff5964;
}
</style>
